import React from "react";
import { useSelector } from "react-redux";
import { Navigate } from "react-router-dom";

const ProtectedRoute = ({ children, permissionKey }) => {
  const roleData = useSelector(
    (state) => state.role.roles
  );
 
  if (!roleData) {
    return children;
  }

  // Dashboard
  if (permissionKey === "isDashboard") {
    return roleData.isDashboard
      ? children
      : <Navigate to="/denied" replace />;
  }

  // Other Modules
  if (roleData?.[permissionKey]?.isRead) {
    return children;
  }

  return <Navigate to="/denied" replace />;
};

export default ProtectedRoute;